import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiService } from 'app/shared/apis/api.service';
import { CompanyService } from 'app/services/company.service';
import { map, of, switchMap, take } from 'rxjs';
import { resolveDriverHomePath } from '../driver-user';
import { REQUESTER_HOME_PATH } from '../requester-user';

/** Redireciona motoristas e solicitantes para o app dedicado quando tentam abrir rotas desktop. */
export const DriverEntryRedirectGuard: CanActivateFn = () => {
    const router = inject(Router);
    const companyService = inject(CompanyService);

    return ApiService.userCurrent.pipe(
        take(1),
        switchMap((user) => {
            const driverHome = resolveDriverHomePath(user);
            if (driverHome) {
                return of(router.parseUrl(driverHome));
            }
            if (user?.is_admin) {
                return of(true);
            }
            return companyService.resolveFirstRequesterCompany().pipe(
                map((company) => {
                    if (!company) {
                        return true;
                    }
                    companyService.setCurrentCompany(company);
                    return router.parseUrl(REQUESTER_HOME_PATH);
                }),
            );
        }),
    );
};
